export const faqs = [
    {
        id: 1,
        category: 'cbt',
        question: `What is Computer Based Test (CBT)?`,
        answer: `Computer based test is the administration of an examination using a computer. This format is flexible in that the test can be taken at different times and in different locations.`,
    },
    {
        id: 2,
        category: 'cbt',
        question: `Why Computer Based Test (CBT)?`,
        answer: `CBT makes for more accurate, precise and fair assessment of the candidates.`,
    },
    {
        id: 3,
        category: 'cbt',
        question: `What are the benefits of Computer Based Test (CBT)?`,
        answer: `(a).It can give immediate feedback  (b).It is accurate and offers automated analysis of results  (c).It is fair  (d).It is more secured  (e).It is the global best practice`,
    },
    {
        id: 4,
        category: 'utme',
        question: `What is e-UTME?`,
        answer: `e-UTME is an electronic form of the Unified Tertiary Matriculation Examination that adopts the use of computer to display and answer test items.`,
    },
    {
        id: 5,
        category: 'cbt',
        question: `What are Computer Based Test (CBT) centres?`,
        answer: `Test centres are examination locations across the country where candidates can take Computer Based Tests (CBT). These centres are equipped with modern infrastructure that would enable the conduct of CBT.`,
    },
    {
        id: 6,
        category: 'cbt',
        question: `Where are the test centres located?`,
        answer: `CBT centres are located in all the thirty-six states of the federation and the FCT.`,
    },
    {
        id: 7,
        category: 'cbt',
        question: `Are these centres well equipped for CBT?`,
        answer: `Yes, the centres are well-equipped for CBT.`,
    },
    {
        id: 8,
        category: 'cbt',
        question: `What does the test centre look like?`,
        answer: `A room equipped with computers connected to Internet or Intranet (Local Area Network).`,
    },
    {
        id: 9,
        category: 'cbt',
        question: `Are the test centres conducive for CBT?`,
        answer: `Yes. The e-UTME accredited professional test centers are certified and equipped to international standards to facilitate a comfortable environment conducive for e-testing. All equipment are provided and there are technical support staff who are available to assist candidates at any time during the examination.`,
    },
    {
        id: 10,
        category: 'cbt',
        question: `How many candidates are attached to a computer?`,
        answer: `A candidate is assigned to a computer.`,
    },
    {
        id: 11,
        category: 'cbt',
        question: `Are international testing centres available?`,
        answer: `Yes, e-UTME accredited testing centres are available in all the seven countries where JAMB conducts its examinations (United Kingdom, Saudi Arabia, South Africa, Republic of Benin, Cameroun, Ghana and Cote 'De Voire).`,
    },
    {
        id: 12,
        category: 'utme',
        question: `How do I pay for my Exam?`,
        answer: `You will purchase your registration ePIN from any designated bank and register at CBT Centre.`,
    },
    {
        id: 13,
        category: 'cbt',
        question: `Will the Computer Based Test follow the same content guidelines of the UTME syllabus?`,
        answer: `Yes`,
    },
    {
        id: 14,
        category: 'cbt',
        question: `Are Computer Based Tests secure`,
        answer: `Yes. The extensive computerized encryption systems make breaking into the test virtually impossible. Also, test centers make it very difficult for candidates to bring in unauthorized materials.`,
    },
    {
        id: 15,
        category: 'cbt',
        question: `How friendly is the CBT to candidates?`,
        answer: `The CBT has been specially designed to provide the necessary atmosphere for the optimum performance of the candidates in terms of layout and simplicity of the questions on the screen. Similarly, moving from one question to another is achieved at the click of the Mouse Button or the movement of the “Arrow Keys”.`,
    },
    {
        id: 16,
        category: 'utme',
        question: `Who do I contact if I have problems submitting my online application?`,
        answer: `Candidates are to direct all enquiries to the ticketing platform at support.jamb.gov.ng`,
    },
    {
        id: 17,
        category: 'utme',
        question: `Will all candidates write the examination at the same time?`,
        answer: `No. Each candidate will write the examination according to a scheduled/appointed time.`,
    },
    {
        id: 18,
        category: 'utme',
        question: `Should I bring the e-slip printout to the testing centre?`,
        answer: `Yes. You should bring the original of your confirmation printout to the centre.`,
    },
    {
        id: 19,
        category: 'cbt',
        question: `How do I start the test?`,
        answer: `You are expected to first key in the registration number into the computer and click on NEXT. You are to read and follow the instructions that comes up. Now, click on START EXAM.`,
    },
    {
        id: 20,
        category: 'cbt',
        question: `How do I key in my answers on a Computer Based Test?`,
        answer: `Answers to questions may be entered into the computer in either of two ways. You may key in answers by clicking on the option you believe to be the answer or typing in the letter of the option. Answers are recorded directly into the computer.`,
    },
    {
        id: 21,
        category: 'cbt',
        question: `May I review my answers or skip questions and answer them later when taking a Computer Based Test?`,
        answer: `Yes. You may review and change your answers after they have been entered into the computer during the examination or after you have attempted to answer all the questions before final submission.`,
    },
    {
        id: 22,
        category: 'cbt',
        question: `How do I know the time I have spent on my examination?`,
        answer: `The time will be displayed on the computer screen during the examination.`,
    },
    {
        id: 23,
        category: 'utme',
        question: `May I bring food to the test centre`,
        answer: `No. Food is not allowed in the test centre.`,
    },
    {
        id: 24,
        category: 'utme',
        question: `May I bring my mobile cell phone to the test centre?`,
        answer: `No. Mobile phones are not allowed in the test centre.`,
    },
    {
        id: 25,
        category: 'utme',
        question: `May I bring notebook to the test centre?`,
        answer: `No. Notebook or other textbook materials are not allowed in the test centre.`,
    },
    {
        id: 26,
        category: 'utme',
        question: `May I bring a calculator to the test centre?`,
        answer: `No. You will be provided with one on the screen on the examination day.`,
    },
    {
        id: 27,
        category: 'cbt',
        question: `If there is a power failure would it affect my timing?`,
        answer: `No. There will be power back-up with alternative power supply and your test will return to the exact place where you stopped. All questions are saved upon answering them.`,
    },
    {
        id: 28,
        category: 'cbt',
        question: `How do I end the test?`,
        answer: `When you have answered and reviewed all the questions, you would be required to click “End Exam” or press “S” on the keyboard, a dialogue box will pop up and ask you to confirm your action, you then click “End Exam” again or press “Y” on the Keyboard to finally end the test.`,
    },
    {
        id: 29,
        category: 'utme',
        question: `Would there be any break during the examination?`,
        answer: `No. There is no break between the test.`,
    },
    {
        id: 30,
        category: 'cbt',
        question: `How can I get more comfortable with CBT before taking an examination?`,
        answer: `You can get more comfortable by choosing to do the mock exam`,
    },
    {
        id: 31,
        category: 'utme',
        question: `How quickly will I receive scores?`,
        answer: `The Board can provide your scores immediately but for scrutiny and other post examination verification exercises, your result would not be instant.`,
    },
    {
        id: 32,
        category: 'cbt',
        question: `Will there be audiovisuals on the Computer Based Test?`,
        answer: `That depends on the test being taken. If visuals contribute to the test, they will be shown on the screen with the text of the questions or in a separate window.`,
    },
    {
        id: 33,
        category: 'cbt',
        question: `Is knowledge of computer programming necessary to take a test on the computer?`,
        answer: `No. The test administration program only requires you to be able to use the mouse or keyboard to answer questions.`,
    },
    {
        id: 34,
        category: 'utme',
        question: `How early should I arrive at the test centre?`,
        answer: `You are expected to arrive two hours earlier before your scheduled time.`,
    },
    {
        id: 35,
        category: 'utme',
        question: `What if I am late for the testing appointment?`,
        answer: `If you arrive after thirty minutes (30mins.) into the examination, you will not be allowed into the testing centre.`,
    },
]